<template>
  <div class="jp-container">
    <jp-page-head />
    <div class="jp-page-wrapper">
      <nuxt />
    </div>
    <Footer />
  </div>
</template>
<script>
import JpPageHead from '@components/Jp/JpPageHead';
import Footer from '@components/Jp/Footer';

export default {
  components: {
    JpPageHead,
    Footer
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/common.scss';

.jp-container {
  min-height: 100vh;
}

.jp-page-wrapper {
  min-height: calc(100vh - 200px);
  padding-top: 80px;
  margin: 0 auto;
}
</style>
